import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import pick from 'lodash/pick'
import { Form } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import withLoadingState from 'loankeeper-common/containers/withLoadingState'
import { translate as translateWebMsg } from 'loankeeper-common/helpers'
import { addClientRiskLevel } from '../../../store/client'
import FormField, { FormLayout } from 'shared/newFormElements'
import withLookups from 'shared/containers/withLookups'
import withLivedata from 'shared/containers/withLivedata'
import { actions as LKModalActions } from 'shared/LKModal'
import LKButton from 'shared/LKButton'

import { actions as DetailsContainerActions } from '../../DetailsContainer'
import translate from '../translate'
import { openFileDetails } from '../../FileDetails'
import { FORM_NAME, MODAL_NAME } from '../constants'
import container from './container'

const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)
const translateWebMessage = (key) => translateWebMsg(`frm_web_messages-${key}`)

const valueSelector = formValueSelector(FORM_NAME)

@withLoadingState
@withLivedata('OpenDayStatus.Open_Day_Str as OpenDay')
@withLookups({ query: 'RiskLevels' })
@container
@connect(
  (state) => ({
    FileID: valueSelector(state, 'FileID'),
  }),
  {
    openFileDetails,
  },
)
@reduxForm({
  form: FORM_NAME,
  validate: (values, props) => {
    const errors = {}

    if (
      !values.OperDate ||
      !LKDate.isValid(values.OperDate) ||
      LKDate.from(values.OperDate).instance.isBefore(LKDate.from(props.OpenDay).instance)
    ) {
      errors.OperDate = translateWebMessage('INVALID_DATE')
    }

    if (values.Comment && values.Comment.length > 300) {
      errors.Comment = 'More than 300 symbols'
    }

    return errors
  },
  onSubmit: (values, dispatch, { ID, hash, linkedfiles }) => {
    let data
    if (values.FileID && values.FileID !== 0) {
      const fileHash = {
        HashSum_FileID_: linkedfiles.find((lf) => lf.ID === values.FileID).HashSum_FileID_,
      }
      data = { ...values, ...fileHash }
    } else {
      data = { ...values }
    }

    dispatch(
      addClientRiskLevel({
        ClientID: ID,
        HashSum_ClientID_: hash,
        ...data,
      }),
    )
      .then(() => {
        dispatch(LKModalActions.close(MODAL_NAME))

        dispatch(
          DetailsContainerActions.fetchPage({
            type: 'Client',
            ID,
            hash,
            page: 'risks',
          }),
        )
      })
      .catch(({ Error }) => {
        dispatch(LKModalActions.openError(translateLKMessage(Error.Message || Error.Text)))
      })
  },
})
class AddForm extends React.Component {
  constructor(props) {
    super(props)

    this.LinkedFiles = this.props.linkedfiles.map(({ ID, Title, TypeTitle }) => ({
      ID,
      Title,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>{ID}</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>{TypeTitle}</div>
          <div>{Title.substring(0, 10)}</div>
        </div>
      ),
    }))

    this.LinkedFiles.unshift({
      ID: 0,
      Title: '-- No File Selected -- ',
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>--</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>--</div>
          <div>--</div>
        </div>
      ),
    })

    const { RiskLevels, OpenDay } = this.props

    this.risks = RiskLevels.filter((level) => level.ID !== 0)

    if (this.props.params && this.props.params.type === 'details') {
      const formData = pick(this.props.params.AMLDetails, [
        'RiskLevelID',
        'OperDate',
        'FileID',
        'Comment',
        'Comment2',
        'Comment_FMS',
      ])
      formData.FileID = this.props.params.AMLDetails.LFLID
      this.props.initialize(formData)
    } else {
      this.props.initialize({
        RiskLevelID: RiskLevels[0].ID,
        OperDate: OpenDay,
        FileID: this.LinkedFiles[0].ID,
      })
    }
    this.state = {
      open: false,
      ID: null,
      hash: null,
    }
  }

  isValidFileExtension = () => {
    const { linkedfiles } = this.props

    if (this.props.FileID) {
      const file = linkedfiles.find((lf) => lf.ID === this.props.FileID)
      return file.Ext.toLowerCase() === 'jpg' || file.Ext.toLowerCase() === 'png' || file.Ext.toLowerCase() === 'pdf'
    }
    return false
  }

  viewFile = () => {
    const { linkedfiles } = this.props

    if (this.props.FileID) {
      const file = linkedfiles.find((lf) => lf.ID === this.props.FileID)

      this.props.openFileDetails({ ID: file.ID, hash: file.HashSum_FileID_, type: file.Ext })
    }
  }

  preventDefault = (event) => event.preventDefault()

  render = () => {
    const { RiskLevels, OpenDay } = this.props

    const risks = RiskLevels.filter((level) => level.ID !== 0)
    const isDisabled = this.props.params && this.props.params.type === 'details'

    return (
      <Form>
        <FormLayout label={translateWebMessage('lbl_date')}>
          <FormField name="OperDate" type="date" from={LKDate.from(OpenDay).instance} disabled={isDisabled} />
        </FormLayout>
        <FormLayout label={translate('lbl_risklevels')}>
          <FormField
            type="select"
            options={risks}
            name="RiskLevelID"
            onBlur={this.preventDefault}
            disabled={isDisabled}
          />
        </FormLayout>
        <FormLayout label={translate('lbl_comment')}>
          <FormField name="Comment" type="textarea" maxLength={300} noResize disabled={isDisabled} />
        </FormLayout>
        <FormLayout label={translate('lbl_comment2')}>
          <FormField name="Comment2" type="textarea" maxLength={300} noResize disabled={isDisabled} />
        </FormLayout>
        <FormLayout label={translate('lbl_comment_fms')}>
          <FormField name="Comment_FMS" type="textarea" maxLength={300} noResize disabled={isDisabled} />
        </FormLayout>
        <div style={{ marginTop: '15px' }}>
          <FormLayout label="KYC File">
            <div>
              <div className="u-flex">
                <FormField
                  type="select"
                  name="FileID"
                  menuWidth={350}
                  options={this.LinkedFiles}
                  onChange={this.handleFileChange}
                  onBlur={this.preventDefault}
                  upward
                />

                <LKButton
                  alias="preview"
                  className="u-marginLeft-5"
                  onClick={this.viewFile}
                  disabled={!this.isValidFileExtension()}
                />
              </div>
            </div>
          </FormLayout>
        </div>
      </Form>
    )
  }
}

export default AddForm
